/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, func, bool, arrayOf, array,
    shape, string, number,
} from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import ReactHtmlParser from 'react-html-parser';
import ReactMarkdown from 'react-markdown';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';
import Image from '../../../../common/Image';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { isEmpty } from '../../../../utils/object';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import configEnv from '../../../../config';

const { PERSIST_KEY } = configEnv;

const styles = (theme) => ({
    contentWrapper: {
        marginTop: 24,
        '& .buttonWrapper': {
            marginTop: 24,
        },
        '& .buttonHDSquare': {
            margin: '0 !important',
            width: 'auto !important',
        },
    },
    singleContent: {
        display: 'flex',
        '& .imageWrapper': {
            flex: 'none',
            marginRight: 24,
        },
        '& .descriptionWrapper': {
            flex: 1,
            '& .productDescription': {
                marginTop: 24,
                maxHeight: 250,
                overflow: 'auto',
            },
            '& .productItemContents': {
                width: '100%',
                height: '160px',
                resize: 'none',
                overflowY: 'scroll',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '0px',
                borderColor: theme.palette.cms?.skuAvailableToShipTextColor,
                marginTop: '10px',
                '& ul': {
                    padding: 'revert-layer',
                },
            },
            '& .contentTitle': {
                fontWeight: '700',
                padding: '8px 0px 3px 3px',
            },
            '& .itemContentsMarkDown': {
                margin: '-10px 0px 0px -17px',
            },
            '& .marginBottom': {
                marginBottom: '4px',
            },
        },
    },
    comparedContentWrapper: {
        display: 'flex',
        marginTop: 24,
    },
    comparedContent: {
        flex: 'none',
        width: 234,
        marginRight: 24,
        '&:last-child': {
            marginRight: 0,
        },
        '& .imageWrapper': {
            marginBottom: 12,
        },
        '& .productDescription': {
            marginTop: 12,
            minHeight: 170,
            maxHeight: 170,
            overflowY: 'auto',
            '& p': {
                margin: 0,
            },
        },
        '& .productItemContents': {
            width: '100%',
            height: '160px',
            resize: 'none',
            overflowY: 'scroll',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '0px',
            borderColor: theme.palette.cms?.skuAvailableToShipTextColor,
            marginTop: '10px',
            '& ul': {
                padding: 'revert-layer',
            },
        },
        '& .contentTitle': {
            fontWeight: '700',
            padding: '8px 0px 3px 3px',
        },
        '& .itemContentsMarkDown': {
            margin: '-10px 0px 0px -17px',
        },

        '& .buttonWrapper': {
            marginTop: 24,
            textAlign: 'center',
            '& .addToCartButton': {
                float: 'none !important',
                margin: '0 !important',
                width: 'auto !important',
                minWidth: 160,
                border: `1px solid ${theme.palette.primaryButton}`,
                '&:hover': {
                    backgroundColor: theme.palette.primaryButton,
                    border: `1px solid ${theme.palette.primaryButton}`,
                },
            },
        },
    },
    itemContentStyleMark: {
        margin: '2px 2px 2px 13px',
        '& ul': {
            margin: '-6px 2px 2px -22px',
        },
        '& p': {
            marginTop: '5px !important',
        },
    },
    giftListImage: {
        width: '100%',
        height: 290,
        objectFit: 'cover',
    },
});

class DesktopGiftListProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasUniqueProduct: [],
        };
    }

    setAddToCart = (isProductId) => {
        const { hasUniqueProduct } = this.state;
        let checkedArr = [];
        checkedArr = [...hasUniqueProduct];
        checkedArr.push(isProductId);
        this.setState({ hasUniqueProduct: checkedArr });
    }

    handleAddToCartClicked = (product, recipient, specialProduct) => {
        let sku = product.id;
        if (product?.id?.includes('-')) {
            sku = product.id.split('-')[2];
        }
        if (specialProduct) {
            const { seoproductDisplayURL, customAttributes } = product;
            const {
                history,
                history: { location: { pathname: giftListURL } },
                remainingRecipient,
                handleConfirmGiftListShopTheSiteClicked,
            } = this.props;
            const recipientWithCounter = { ...recipient, remainingRecipient, giftListURL };
            handleConfirmGiftListShopTheSiteClicked(
                recipientWithCounter,
                seoproductDisplayURL || customAttributes?.parentProduct?.seo?.url || product?.seo?.url,
                false,
                customAttributes?.deliveryIndicator,
                customAttributes?.productType,
            );
            if (seoproductDisplayURL || product?.seo?.url) history.push(seoproductDisplayURL || product?.seo?.url);
            else if (customAttributes?.parentProduct?.seo?.url) history.push(customAttributes?.parentProduct?.seo?.url);
        } else {
            const { handleGiftListAddToCart } = this.props;
            handleGiftListAddToCart(sku, recipient, true);
        }
    }

    // this will render quick view contents for club items from aggregator response
    clubQuickViewContents = () => {
        const {
            product,
        } = this.props;
        const clubItemContents = product?.customAttributes?.clubItem?.components || [];
        return (
            <div className="itemContentsMarkDown">
                <ul>
                    {
                        clubItemContents?.map((club) => (
                            <li className="marginBottom">{club.month} : {club.name} </li>
                        ))
                    }
                </ul>
            </div>
        );
    };

    singleProductDetailTemplate = (specialProduct) => {
        const {
            classes, isReadyState, product, recipient, emitCustomClickTrackingEvent, salesforceAPIResponse,
        } = this.props;
        const productName = product.name || '';
        const newName = htmlDecode(productName);
        const imageURL = (product.image) ? product.image.replace(/^http[s]?:/, 'https:') : '';
        const productItemContents = product.itemContents || '';
        const hasItemContentStyle = productItemContents?.includes('style=') || productItemContents?.includes('<p><strong>');
        const currentSalesforceCampaign = salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) ? salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) : {};

        return (
            <>
                <div className={classes.contentWrapper}>
                    <div className={classes.singleContent}>
                        <div className="imageWrapper">
                            <Image
                                className="flex-none"
                                src={imageURL}
                                alt={newName}
                                style={{ maxWidth: '350px', width: '350px' }}
                            />
                        </div>
                        <div className="descriptionWrapper">
                            <div>
                                <div className="bold">{ReactHtmlParser(newName)}</div>
                                <div>Item: {product.sku || product.id}</div>
                                <div>
                                    Price:{' '}
                                    {product.discountPrice ? (
                                        <>
                                            <span className="bold crossed-price">
                                                {product.crossedPrice}
                                            </span>
                                            <span className="bold discount-price">
                                                ${product.discountPrice}
                                            </span>
                                        </>
                                    ) : (
                                        <span className="bold">${product.price}</span>
                                    )}
                                </div>
                                <div className="bold small">{product.status}</div>
                            </div>
                            {productItemContents
                                ? (
                                    <div className="productItemContents">
                                        <div className="contentTitle"><span>Contents</span></div>
                                        <ReactMarkdown source={productItemContents} escapeHtml={false} className={hasItemContentStyle && classes.itemContentStyleMark} />
                                    </div>
                                )
                                : this.clubQuickViewContents()}
                        </div>
                    </div>
                    <div className="buttonWrapper">
                        <Button
                            className="no-margin"
                            onClick={() => {
                                this.handleAddToCartClicked(product, recipient, specialProduct);
                                emitCustomClickTrackingEvent({
                                    action: 'Click',
                                    partNumber: product?.oGPartNumber,
                                    salesforceResponse: currentSalesforceCampaign,
                                    experimentTracking: product?.experimentTracking,
                                    page: { type: 'gift-list' },
                                    eventSubType: 'campaign-tracking',
                                });
                            }}

                        >
                            {isReadyState
                                ? `Add For ${recipient.firstname} ${recipient.lastname}`
                                : 'Adding...'}
                        </Button>
                    </div>
                </div>
            </>
        );
    }

    comparedContent = (product) => {
        const {
            classes, recipient, emitCustomClickTrackingEvent, salesforceAPIResponse,
        } = this.props;
        const { hasUniqueProduct } = this.state;
        const productName = product.name || '';
        const newName = htmlDecode(productName);
        const imageURL = typeof product.image === 'string' ? product.image.replace(/^http[s]?:/, 'https:') : product.image.fullPath;
        const productItemContents = product.itemContents || product.description || '';
        const hasItemContentStyle = productItemContents?.includes('style=') || product.description;

        const isProductId = product.id || {};

        const customAttributes = product.customAttributes || null;
        const personalization = product.customAttributes?.personalization || null;
        const parentProduct = product.customAttributes?.parentProduct || null;
        const ageVerifyFlag = (!isEmpty(customAttributes) && customAttributes?.ageVerifyFlag) ? customAttributes.ageVerifyFlag : 'false';
        const personalizationTemplate = (!isEmpty(personalization) && personalization?.personalizationTemplate) ? personalization.personalizationTemplate : 'N';
        const personalizationType = (!isEmpty(personalization) && personalization?.personalizationType) ? personalization.personalizationType : null;
        const specialProductNames = ['pick', 'choose', 'wine'];
        const specialProduct = ageVerifyFlag !== 'false'
            || parentProduct?.productType === 'CLUB'
            || parentProduct?.productType === 'COLLECTION'
            || parentProduct?.productType === 'CUSTOM_ASSORTMENT'
            || (
                !['REGULAR_PRODUCT', 'REGULARPRODUCT'].includes(parentProduct?.productType)
                && (
                    personalizationTemplate === 'Y'
                    || personalizationType === 'G'
                    || personalizationType === '0'
                )
            )
            || specialProductNames.some((pName) => product.name.toLowerCase().includes(pName));
        const defaultAddToCartLabel = (specialProduct) ? 'Make Selections' : 'Add To Cart';

        const isClickCompareProduct = hasUniqueProduct?.includes(product.id);
        const currentSalesforceCampaign = salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) ? salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) : {};
        return (
            <>
                <div className={classes.comparedContent}>
                    <div className="imageWrapper">
                        <Image
                            className={`flex-none ${classes.giftListImage}`}
                            src={imageURL}
                            alt={newName}
                        />
                    </div>
                    <div className="descriptionWrapper">
                        <div>
                            <div className="bold line-clamp-2">{ReactHtmlParser(newName)}</div>
                            <div>Item: {product.sku}</div>
                            <div>
                                Price:{' '}
                                {product.discountPrice ? (
                                    <>
                                        <span className="bold crossed-price">
                                            {product.crossedPrice}
                                        </span>
                                        <span className="bold discount-price">
                                            ${product.discountPrice}
                                        </span>
                                    </>
                                ) : (
                                    <span className="bold">${product.price}</span>
                                )}
                            </div>
                            <div className="bold small">{product.status}</div>
                        </div>
                        <div className="productItemContents">
                            <div className="contentTitle"><span>Contents</span></div>
                            {productItemContents ? <ReactMarkdown source={productItemContents} escapeHtml={false} className={hasItemContentStyle ? classes.itemContentStyleMark : 'itemContentsMarkDown'} /> : this.clubQuickViewContents()}
                        </div>
                        <div className="buttonWrapper align-center" tabIndex={0} role="button" onKeyDown={() => { }} onClick={() => this.setAddToCart(isProductId)}>
                            <Button
                                className="no-margin float-none"
                                onClick={() => {
                                    this.handleAddToCartClicked(product, recipient, specialProduct);
                                    emitCustomClickTrackingEvent({
                                        action: 'Click',
                                        partNumber: product?.oGPartNumber,
                                        salesforceResponse: currentSalesforceCampaign,
                                        experimentTracking: product?.experimentTracking,
                                        page: { type: 'gift-list' },
                                        eventSubType: 'campaign-tracking',
                                    });
                                }}
                            >
                                {!isClickCompareProduct
                                    ? defaultAddToCartLabel
                                    : 'Adding...'}
                            </Button>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    compareProductDetailTemplate = (specialProduct) => {
        const {
            classes, comparedProducts,
        } = this.props;
        return (
            <>
                <div className={classes.comparedContentWrapper}>
                    {comparedProducts.map((product) => this.comparedContent(product, specialProduct))}
                </div>
            </>
        );
    }

    render() {
        const { product, comparedProducts } = this.props;
        if (isEmpty(product)) return null;
        const {
            customAttributes: { personalization, parentProduct },
            customAttributes,
        } = product;
        const ageVerifyFlag = (!isEmpty(customAttributes) && customAttributes?.ageVerifyFlag) ? customAttributes.ageVerifyFlag : 'false';
        const personalizationType = (!isEmpty(personalization) && personalization?.personalizationType) ? personalization.personalizationType : null;
        const personalizationTemplate = (!isEmpty(personalization) && personalization?.personalizationTemplate) ? personalization.personalizationTemplate : 'N';
        const specialProductNames = ['pick', 'choose', 'wine'];
        const specialProduct = ageVerifyFlag !== 'false'
            || parentProduct?.productType === 'CLUB'
            || parentProduct?.productType === 'COLLECTION'
            || parentProduct?.productType === 'CUSTOM_ASSORTMENT'
            || (
                !['REGULAR_PRODUCT', 'REGULARPRODUCT'].includes(parentProduct?.productType)
                && (
                    personalizationTemplate === 'Y'
                    || personalizationType === 'G'
                    || personalizationType === '0'
                )
            )
            || specialProductNames.some((pName) => product.name.toLowerCase().includes(pName));

        return (comparedProducts.length < 2 ? this.singleProductDetailTemplate(specialProduct) : this.compareProductDetailTemplate(specialProduct));
    }
}

DesktopGiftListProductDetails.defaultProps = {
    product: {},
    comparedProducts: [],
    handleConfirmGiftListShopTheSiteClicked: () => { },
    history: {},
    salesforceAPIResponse: [],
    emitCustomClickTrackingEvent: () => { },
};

DesktopGiftListProductDetails.propTypes = {
    classes: object.isRequired,
    history: object,
    product: shape({
        content: string,
        crossedPrice: string,
        discountPrice: string,
        id: string,
        image: string,
        name: string,
        parentCatalogEntryId: string,
        partNumber: string,
        price: number,
        seoproductDisplayURL: string,
        sku: string,
        status: string,
    }),
    comparedProducts: arrayOf(
        shape({
            content: string,
            crossedPrice: string,
            discountPrice: string,
            id: string,
            image: string,
            name: string,
            parentCatalogEntryId: string,
            partNumber: string,
            price: number,
            seoproductDisplayURL: string,
            sku: string,
            status: string,
        }),
    ),
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        NamePrefix: string,
        FirstName: string,
        MiddleInitial: string,
        LastName: string,
        NameSuffix: string,
        RelationShip: string,
        NickName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        AlternatePhoneNumber: string,
        Fax: string,
        EmployerName: string,
        NumberOfAddresses: number,
        DateOfBirth: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                IsPartialMatch: bool,
                IsUnknownAddress: bool,
                Latitude_degrees: number,
                Longitude_degrees: number,
                IsBillingAddress: bool,
                ContactId: number,
            }),
        ),
    }).isRequired,
    isReadyState: bool.isRequired,
    handleGiftListAddToCart: func.isRequired,
    remainingRecipient: number.isRequired,
    handleConfirmGiftListShopTheSiteClicked: func,
    salesforceAPIResponse: array,
    emitCustomClickTrackingEvent: func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        product: newState.modal.content.product,
        recipient: newState.modal.content.recipient,
        comparedProducts: newState.modal.content.comparedProducts,
        isReadyState: newState.isReadyState,
        remainingRecipient: newState.giftList.remainingRecipient,
        salesforceAPIResponse: newState.giftList.salesforceAPIResponse,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListAddToCart: (productId, recipient, closeModal) => dispatch(EventDispatcher.handleGiftListAddToCart(productId, recipient, closeModal)),
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal, deliveryIndicator, productType) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
        deliveryIndicator,
        productType,
    )),
    emitCustomClickTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopGiftListProductDetails)));
